var product_list = [
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S214) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S214) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk. III) (5-Türer) SUV | 2013-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Avant (5-Türer) Kombi | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "MDX (Mk. IV) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tayron (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Kombi | 2013-2019",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "J8 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "J8 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 Cross Country (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "QS (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G61) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G61) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Samsung QM6 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tipo (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2008-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2006-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S213) (5-Türer) Kombi | 2016-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S213) (5-Türer) Kombi | 2017-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro (DE) (DE) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2014-2019",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C6) (5-Türer) Kombi | 2005-2010",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk III) (5-Türer) SUV | 2010-2016",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (FY) (5-Türer) SUV | 2017-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQA (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.4 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 (5-Türer) SUV | 2012-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PERODUA",
    "Mo": "Aruz (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2014-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea XL (5-Türer) MPV | 2006-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Wagoneer (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima Sportswagon (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rush (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2016-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2018-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (F11) (5-Türer) Kombi | 2010-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV60 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (X156) (5-Türer) SUV | 2014-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (4-Türer) Van | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS SUV (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Van | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Townstar (4-Türer) Van | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Double Cab (4-Türer) Pickup | 2016-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "PV5 Passenger (5-Türer) MPV | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Schrägheck | 2003-2008",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Enyaq Coupé iV (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 Sportback (5-Türer) SUV | 2021-2025",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Wagoneer S (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Han (4-Türer) Stufenheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta (Type VI) (4-Türer) Stufenheck | 2010-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron (5-Türer) SUV | 2019-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk VI) (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Altima (4-Türer) Stufenheck | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "2 (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "e-Golf (5-Türer) Schrägheck | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (Mk III) (4-Türer) Stufenheck | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Schrägheck | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i10 (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LBX (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LBX (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2006-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant e-tron (5-Türer) Kombi | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K4 (4-Türer) Stufenheck | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Liberty (4-Türer) Stufenheck | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (F26) (5-Türer) SUV | 2015-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2015-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Crew Cab | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (5-Türer) Schrägheck | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV6 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka ((B)) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PERODUA",
    "Mo": "MyVi (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (4-Türer) Stufenheck | 2004-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2008-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VIII) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2002,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2003,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox Wagon (XP50) (5-Türer) MPV | 2002-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Crown Crossover (S235) (4-Türer) Stufenheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "UP! (3-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note II (E12) (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Avenger (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "e-208 (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2013-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (5-Türer) Schrägheck | 2008-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Colt (5-Türer) Schrägheck | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (3-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. IV) (5-Türer) Schrägheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "WR-V II (DG4) (DG4) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW20) (5-Türer) Schrägheck | 2004-2008",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B6/ B7) (4-Türer) Stufenheck | 2005-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2011-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max with sliding doors (5-Türer) MPV | 2010-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. III) (4-Türer) Stufenheck | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (4-Türer) Stufenheck | 2008-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "City (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "2 Hybrid (XP210) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Toledo (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (III) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "Y": 2002,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "Y": 2003,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2002-2006",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Mo": "Rampage (4-Türer) Crew Cab | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RAM",
    "Mo": "Rampage (4-Türer) Crew Cab | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Ariya (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Funky Cat (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (K) (5-Türer) Kombi | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. IV) (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk. IV) (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "E-3008 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "E-3008 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado (4-Türer) Crew Cab | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Verso (5-Türer) MPV | 2004-2008",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (II) (5-Türer) Schrägheck | 2005-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (LF) (4-Türer) Stufenheck | 2015-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aygo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "EX30 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "EX30 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl (5-Türer) Schrägheck | 2015-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (4-Türer) Stufenheck | 2011-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D40) (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2012-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Stinger (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Schrägheck | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2014-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "C40 Recharge (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. I) (5-Türer) SUV | 2010-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vitz (XP130) (5-Türer) Schrägheck | 2010-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Morning (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2002,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2003,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk. IV) (5-Türer) Schrägheck | 2002-2009",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 5 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk. II) (5-Türer) Schrägheck | 2007-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2007-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2007-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "3 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "3 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "4 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "POLESTAR",
    "Mo": "4 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (AH40) (5-Türer) MPV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix20 (5-Türer) Schrägheck | 2010-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fusion (4-Türer) Stufenheck | 2013-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Malibu (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron Sportback (5-Türer) SUV | 2020-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Alphard (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2006,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2007,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2008,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2009,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2010,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2011,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2012,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2013,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2014,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2015,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (3V) (5-Türer) Schrägheck | 2015-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (5-Türer) SUV | 2004-2013",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (F48) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) MPV | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2014,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2015,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2016,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2017,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2018,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2014-2019",
    "Y": 2019,
    "c": "g",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "C-Max without sliding door (5-Türer) MPV | 2010-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOYAH",
    "Mo": "Courage (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Panda (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 500 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (MX5) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (MX5) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLB (X247) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Coupé (F44) (4-Türer) Coupe | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kamiq (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Xpander Cross (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (Mk. III) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "5 (Mk. II) (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2001-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2008-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (5-Türer) MPV | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Kombi | 2009-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 1999-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1995-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W166) (5-Türer) SUV | 2012-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2003-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1990-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vaneo (5-Türer) MPV | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (5-Türer) SUV | 2007-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 (5-Türer) Schrägheck | 2006-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (5-Türer) Kombi | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1995-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk II) (5-Türer) Kombi | 2007-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Justy (5-Türer) MPV | 2003-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 1995-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "R'Nessa (5-Türer) Kombi | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (3-Türer) SUV | 1993-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Monterey (5-Türer) SUV | 1993-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2006-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2002-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (5-Türer) Van | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Endeavor (5-Türer) SUV | 2006-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper Tepee (5-Türer) MPV | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 1997-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (II) (5-Türer) Kombi | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Corsa (5-Türer) Kombi | 1993-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Sintra (5-Türer) MPV | 1997-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1980,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1981,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1982,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3) (5-Türer) Kombi | 1980-1987",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (5-Türer) MPV | 1996-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2006-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KJ) (5-Türer) SUV | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Sprinter (5-Türer) Kombi | 1998-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk II) (5-Türer) Schrägheck | 2005-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H8 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina E (5-Türer) Kombi | 1993-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 1993-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "PV5 Cargo (4-Türer) Van | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV350 (5-Türer) Bus | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C254) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W214) (4-Türer) Stufenheck | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W214) (4-Türer) Stufenheck | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (2E) (4-Türer) Van | 2006-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1T (4-Türer) Pickup | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2003-2014",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (5-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (5-Türer) Van | 2013-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (5-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Ulysse (5-Türer) Bus | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "Y": 2001,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "Y": 2002,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2001-2004",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) Van | 2009-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL30) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2012-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) SUV | 2010-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (3-Türer) Schrägheck | 2004-2012",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk III) (5-Türer) SUV | 2004-2009",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (V177) (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2020-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Schrägheck | 2005-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV250 (4-Türer) Van | 2019-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. III) (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (2-Türer) Einzelkabine | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (V223) (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2012-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Courier (4-Türer) Van | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MX-30 (DR) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk II) (5-Türer) Kombi | 2004-2007",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Seltos (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fullback Extended Cab (2-Türer) Pickup | 2016-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Bus | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (III) (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q7 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2014-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "Como (5-Türer) Van | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Doppelkabine | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Movano (4-Türer) Van | 2010-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ZEEKR",
    "Mo": "7GT (5-Türer) Kombi | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-80 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-80 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Gran Tourer (F46) (5-Türer) MPV | 2015-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Colorado7 (5-Türer) SUV | 2012-2016",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 8 Pro PHEV (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C9) (5-Türer) Kombi | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "EX90 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Song Plus (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Lodgy (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2003,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (III) (5-Türer) Kombi | 2003-2009",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X (A) (5-Türer) SUV | 2016-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt EUV (5-Türer) SUV | 2022-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt EUV (5-Türer) SUV | 2022-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra Sports Tourer (J) (5-Türer) Kombi | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "Jolion (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Tasman (4-Türer) Pickup | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka X (5-Türer) SUV | 2016-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (HM) (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2014-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (G31) (5-Türer) Kombi | 2017-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Leon ST (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C7) (5-Türer) Kombi | 2011-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2014-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "8 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "8 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X4 (G02) (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "Yukon (5-Türer) SUV | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i5 Touring (G61) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i5 Touring (G61) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X6 (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "J7 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Trailblazer (5-Türer) SUV | 2017-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Agila (5-Türer) MPV | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Elysion (5-Türer) MPV | 2004-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Atenza (5-Türer) Kombi | 2002-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2004-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 1998-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 1998-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "RVR (5-Türer) MPV | 1992-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Lavita (5-Türer) MPV | 2001-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C300) (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BRILLIANCE",
    "Mo": "BS4 (5-Türer) Kombi | 2009-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1994-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "306 (5-Türer) Kombi | 1997-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 2002-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2000-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Palio (5-Türer) Kombi | 1997-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Onix Activ (5-Türer) Schrägheck | 2016-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Sportwagon (5-Türer) Kombi | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "200 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E36) (5-Türer) Kombi | 1996-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2006-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 1997-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "BX (5-Türer) Kombi | 1989-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Getz Cross (5-Türer) Schrägheck | 2006-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Cross (5-Türer) Kombi | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (5-Türer) Van | 2008-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado 250 (250) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado 250 (250) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R50) (5-Türer) SUV | 1996-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "SRX (5-Türer) SUV | 2005-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Kombi | 2013-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VII) (5-Türer) Kombi | 2013-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2009-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster (5-Türer) MPV | 2006-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Marea (5-Türer) Kombi | 1996-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 1997-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2102 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2006-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A7) (5-Türer) Kombi | 2015-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Alltrack (A8) (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1997-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2003-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Star (5-Türer) MPV | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2008-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX70 (5-Türer) SUV | 2013-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Uplander (5-Türer) Van | 2005-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (3-Türer) Van | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iLoad (5-Türer) Van | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 100 (5-Türer) SUV | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (5-Türer) Kombi | 2001-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Picasso (5-Türer) MPV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk I) (5-Türer) MPV | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Rien SRV (5-Türer) SUV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (5-Türer) SUV | 1993-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-5 (5-Türer) Kombi | 1999-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Alaskan (4-Türer) Doppelkabine | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S210) (5-Türer) Kombi | 1996-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Murano (5-Türer) SUV | 2003-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (4-Türer) MPV | 1997-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Quantum (5-Türer) Kombi | 1991-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Cefiro (5-Türer) Kombi | 1997-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Voyager/Grand Voyager (5-Türer) MPV | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2003-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Capella (5-Türer) Kombi | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Plus (5-Türer) Schrägheck | 2005-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2008-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "X-Class (4-Türer) Doppelkabine | 2018-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2008-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2005-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2005-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1986-1993",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (BT) (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (GJ/GL) (5-Türer) Kombi | 2013-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. II) (5-Türer) SUV | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "940 (5-Türer) Kombi | 1990-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "207 SW (5-Türer) Kombi | 2006-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Freemont (5-Türer) SUV | 2012-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spin (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2010-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Polo (5-Türer) Schrägheck | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 1997-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V90 (5-Türer) Kombi | 1997-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (II) (5-Türer) Kombi | 1994-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W163) (5-Türer) SUV | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (W166) (5-Türer) SUV | 2015-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "HHR (5-Türer) MPV | 2007-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "BLS (5-Türer) Kombi | 2006-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B7) (5-Türer) Kombi | 2012-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1992-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "80 Avant (5-Türer) Kombi | 1992-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) MPV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (F60) (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "EX37 (5-Türer) SUV | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Kadett (5-Türer) Kombi | 1985-1991",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (5-Türer) Kombi | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E46) (5-Türer) Kombi | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1999-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S124) (5-Türer) Kombi | 1985-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 1993-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot Grandis (5-Türer) MPV | 1997-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (V) (5-Türer) Kombi | 2007-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (Mk II) (5-Türer) MPV | 2006-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. II) (5-Türer) Kombi | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (Mk II) (5-Türer) MPV | 2006-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Croma (5-Türer) Kombi | 2005-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 2007-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fun Cargo (5-Türer) MPV | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1985-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Raum (5-Türer) MPV | 1997-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2000-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "2104 Nova (5-Türer) Kombi | 1984-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (5-Türer) Kombi | 2007-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb Alldrive (Mk II) (5-Türer) Kombi | 2012-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (Mk. I) (5-Türer) SUV | 2001-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Escudo (5-Türer) SUV | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 1994-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 1999-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "TB (5-Türer) Schrägheck | 2006-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Xenon (4-Türer) Doppelkabine | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 1996-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Hustler (5-Türer) MPV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Yeti (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Kyron (5-Türer) SUV | 2005-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Dakar (5-Türer) SUV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carib (5-Türer) Kombi | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (I) (5-Türer) Kombi | 1989-1993",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "Streetwise (3-Türer) Schrägheck | 2004-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "eK X (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2005-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B3/B4) (5-Türer) Kombi | 1988-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (5-Türer) Van | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (5-Türer) Van | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan (4-Türer) Stufenheck | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series (G22) (2-Türer) Coupe | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan/eCitan (4-Türer) Van | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (Mk. II) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Citan (4-Türer) Van | 2013-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce Verso (5-Türer) Bus | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (5-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2013-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T5) (T5) (4-Türer) Bus | 2003-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "F-Pace (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3L (5-Türer) SUV | 2021-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Shark (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Shark (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID. UNYX (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis (5-Türer) Kombi | 2009-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "XT6 (5-Türer) SUV | 2020-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C167) (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2007-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X117) (5-Türer) Kombi | 2015-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W206) (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Prologue (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Prologue (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W212) (4-Türer) Stufenheck | 2009-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Tasman (4-Türer) Pickup | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2007,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2008,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2009,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2010,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2011,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2012,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2013,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2014,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Commander (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "C-HR (Mk. I) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks Play (P15) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks Play (P15) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero II (5-Türer) Schrägheck | 2013-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero (5-Türer) Schrägheck | 2008-2012",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W177) (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQS (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2011-2016",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C118) (4-Türer) Coupe | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "09 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "09 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "09 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "09 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "09 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "03 (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "4 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEAPMOTOR",
    "Mo": "C11 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Boreal (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2012-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (5-Türer) Schrägheck | 1995-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Matiz (5-Türer) Schrägheck | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (ZJ) (5-Türer) SUV | 1993-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 150 (5-Türer) SUV | 2009-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2007-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 1997-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai +2 (5-Türer) SUV | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (3-Türer) Schrägheck | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Equinox (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2013-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Almera (5-Türer) Kombi | 1999-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2000-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk II) (5-Türer) SUV | 2007-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2002-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "206 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santamo (5-Türer) MPV | 1996-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Clarus (5-Türer) Kombi | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S211) (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4007 (5-Türer) SUV | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Ateca (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Karoq (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2016-2025",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Aerodeck (5-Türer) Kombi | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (5-Türer) MPV | 1999-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Carina II (5-Türer) Kombi | 1988-1991",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (5-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Verso (5-Türer) MPV | 2009-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia Scout (Mk II) (5-Türer) Schrägheck | 2009-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 SW (5-Türer) Kombi | 2002-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R+ (5-Türer) MPV | 1997-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2005-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W11) (5-Türer) Kombi | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V70 (5-Türer) Kombi | 2000-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Forenza (5-Türer) Kombi | 2004-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. III) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. III) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Caldina (5-Türer) Kombi | 1996-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2002-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz Crosstar (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Tempra (5-Türer) Kombi | 1989-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "960 (5-Türer) Kombi | 1990-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1983-1986",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (Mk. III) (4-Türer) Van | 2004-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (5-Türer) Kombi | 2013-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Windstar (5-Türer) MPV | 1995-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Sandero Stepway (5-Türer) Schrägheck | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (5-Türer) SUV | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1995-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Laguna (5-Türer) Kombi | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Gracia (5-Türer) Kombi | 1997-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (5-Türer) MPV | 2007-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 1997-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AION",
    "Mo": "V (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AION",
    "Mo": "V (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Livina X-Gear (5-Türer) MPV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Karl Rocks (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 1993-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 X-TR (5-Türer) MPV | 2004-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand C-Max (5-Türer) MPV | 2010-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. I) (5-Türer) SUV | 2008-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2001-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 1996-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (VI) (5-Türer) Kombi | 2010-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi California (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Edix (5-Türer) MPV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Felicia (5-Türer) Kombi | 1996-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander (5-Türer) SUV | 1998-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B6) (5-Türer) Kombi | 2005-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suprema (5-Türer) Kombi | 1986-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TATA",
    "Mo": "Indigo (5-Türer) SUV | 2004-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Suran (5-Türer) Kombi | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Nimbus (5-Türer) MPV | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Tacuma (5-Türer) Kombi | 2000-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk I) (5-Türer) Kombi | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan MCV (5-Türer) Kombi | 2013-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (5-Türer) MPV | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Omega (5-Türer) Kombi | 1994-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Idea (5-Türer) MPV | 2003-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Matrix (5-Türer) MPV | 2001-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 200 (5-Türer) SUV | 2008-2021",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover (5-Türer) SUV | 1998-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Golf (5-Türer) Schrägheck | 2006-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (5-Türer) SUV | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk I) (5-Türer) SUV | 1996-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "H-1 (4-Türer) Van | 1997-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk II) (5-Türer) Kombi | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "159 (5-Türer) Kombi | 2006-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2016-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 300 (J30) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Cannon (4-Türer) Pickup | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Renegade (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder R52 (R52) (5-Türer) SUV | 2013-2021",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (3-Türer) SUV | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk III) (5-Türer) Kombi | 2015-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Feroza (3-Türer) SUV | 1988-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "XM (5-Türer) Kombi | 1989-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Chariot (5-Türer) MPV | 1992-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tarago (5-Türer) MPV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Top (5-Türer) MPV | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2008-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE (V167) (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Estima (5-Türer) MPV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "407 SW (5-Türer) Kombi | 2004-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "156 Crosswagon (5-Türer) Kombi | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trans Sport (4-Türer) MPV | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Cherokee (KK) (5-Türer) SUV | 2008-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (5-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2007-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (3-Türer) SUV | 2003-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 1991-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W202) (5-Türer) Kombi | 1993-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1992-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. II) (5-Türer) Kombi | 2004-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "300C (5-Türer) Kombi | 2004-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 2000-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 2000-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (5-Türer) SUV | 1986-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 90 (5-Türer) SUV | 2003-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (II) (5-Türer) Kombi | 1994-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (5-Türer) SUV | 1999-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Spacia (5-Türer) MPV | 2017-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H9 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada Adventure (2-Türer) Pickup | 2014-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero iO (5-Türer) SUV | 1998-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery Sport (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Pride (3-Türer) Schrägheck | 1995-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (III) (5-Türer) Kombi | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda Cross (5-Türer) SUV | 2014-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (IV) (5-Türer) Kombi | 1999-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Patriot (5-Türer) SUV | 2006-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Aspen (5-Türer) SUV | 2007-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (Mk. X) (5-Türer) Kombi | 2006-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escort (5-Türer) Kombi | 1991-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "405 (5-Türer) Kombi | 1989-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Runner (5-Türer) MPV | 1992-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Grand Carnival (5-Türer) MPV | 2006-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Fun (5-Türer) Schrägheck | 2003-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "406 (5-Türer) Kombi | 1997-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Verso (5-Türer) MPV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Presage (5-Türer) MPV | 2003-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Touring (E61) (5-Türer) Kombi | 2004-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Grandis (5-Türer) MPV | 2003-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 1996-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (B9) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (B9) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T7) (4-Türer) Van | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T7) (4-Türer) Bus | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "06 EM-P (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "7 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "7 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAECOO",
    "Mo": "7 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA Shooting Brake (X118) (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G30) (4-Türer) Stufenheck | 2017-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T7) (4-Türer) Bus | 2022-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (5-Türer) SUV | 2012-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (F36) (4-Türer) Coupe | 2014-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (3-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (4-Türer) MPV | 2004-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T7) (4-Türer) Van | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series Gran Turismo (5-Türer) Schrägheck | 2009-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Viano (5-Türer) MPV | 2004-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "SpaceTourer (5-Türer) Bus | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "G-Class (W463 2nd gen) (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC Coupé (C253) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "307 (5-Türer) Schrägheck | 2005-2008",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ20) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2004-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Connect (4-Türer) Van | 2003-2013",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) MPV | 2008-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2003-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 1996,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 1997,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 1998,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 1999,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 2000,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 2001,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 2002,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 1996-2003",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2013-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (H) (5-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vivaro (C) (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 (Mk. II) (5-Türer) Schrägheck | 2015-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W169) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU50) (5-Türer) SUV | 2014-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 2008-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. IV) (5-Türer) Schrägheck | 2012-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2008-2013",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Gran Turismo (5-Türer) Schrägheck | 2014-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo Maxi (5-Türer) Van | 2010-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (G20) (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 5-seater (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Fastback (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GU) (5-Türer) Schrägheck | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (V) (5-Türer) Kombi | 2009-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "6-Series Gran Turismo (G32) (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Cross (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series (G42) (2-Türer) Coupe | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (II) (4-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Traveller (5-Türer) Bus | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan PanAmericana (T6/T6.1) (T6) (4-Türer) Bus | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (F30) (4-Türer) Stufenheck | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (5-Türer) Schrägheck | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X7 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk IV) (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Creta (GS/GSb) (5-Türer) SUV | 2017-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class All-Terrain (S206) (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class All-Terrain (S214) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Life (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Navigator (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B9) (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B9) (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "EX40 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "EX40 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Arona (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q6 e-tron (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (E91) (5-Türer) Kombi | 2005-2011",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (R60) (5-Türer) SUV | 2010-2016",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León X-Perience (5-Türer) Kombi | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) Schrägheck | 2014-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Vectra (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2008-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (Mk III) (5-Türer) Kombi | 2011-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Alltrack (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (U25) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Countryman (U25) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S205) (5-Türer) Kombi | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (5-Türer) Kombi | 2015-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Eclipse Cross (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Avant (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Equinox EV (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Equinox EV (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "León ST (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GT) (5-Türer) SUV | 2019-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Koleos (Mk. II) (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "Y": 2003,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2003-2007",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B8) (5-Türer) Kombi | 2015-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (5-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz Cargo (Short Wheel Base) (Short Wheel Base) (4-Türer) Van | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Vivaro Life (5-Türer) Bus | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Interstar (4-Türer) Van | 2021-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (MDX_) (4-Türer) Van | 2013-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2003-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Short Wheel Base) (Short Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Jumpy (4-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Doppelkabine | 2010-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (BP) (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i40 (5-Türer) Kombi | 2011-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta Active (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Aceman (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX L (5-Türer) SUV | 2018-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Rifter (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2010-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Territory (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Territory (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 e-tron (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U375) (5-Türer) SUV | 2016-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (C8) (5-Türer) Kombi | 2019-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "NX-Series (AZ10) (5-Türer) SUV | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Grand Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia Country Tourer (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Atto 3 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P16) (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "01 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (S206) (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Pilot (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Cross Turismo (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (3-Türer) SUV | 2005-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2010-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2018-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "508 (5-Türer) Kombi | 2011-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "TrailBlazer (5-Türer) SUV | 2012-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X254) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Fortuner (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "EHS (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza ST (5-Türer) Kombi | 2010-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2004-2006",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "UX-Series (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Custom (5-Türer) Bus | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV70 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "LX-Series (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2003,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2004,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (IV) (5-Türer) Kombi | 2003-2009",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Talisman (5-Türer) Kombi | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHERY",
    "Mo": "Tiggo 4 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Grand Picasso (5-Türer) MPV | 2014-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2011-2014",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX30 (5-Türer) Schrägheck | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "MU-X (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HAVAL",
    "Mo": "H6 (Mk. III) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "WEY",
    "Mo": "Coffee 01 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Everest (U704) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-8 (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X2 (F39) (5-Türer) SUV | 2018-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GENESIS",
    "Mo": "GV80 Coupe (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (3-Türer) Van | 2008-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "ProAce City (4-Türer) Van | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. I) (5-Türer) Kombi | 1996-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce Regius (5-Türer) MPV | 1997-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (4-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Atos (5-Türer) Schrägheck | 1998-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Galant (5-Türer) Kombi | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. II) (5-Türer) SUV | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (R53) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2006-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "1007 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 1990-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Lybra (5-Türer) Kombi | 1999-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (4-Türer) SUV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Rexton (W) (5-Türer) SUV | 2012-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo Malibu (5-Türer) MPV | 2000-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2010-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 1995-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Tarraco (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2005-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (3-Türer) SUV | 2005-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Joice (5-Türer) MPV | 2000-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2004-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "FR-V (5-Türer) MPV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Stagea (5-Türer) Kombi | 1997-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "Refine (5-Türer) MPV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NP300 (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Veracruz (5-Türer) Van | 2008-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda 4X4 (5-Türer) Schrägheck | 2004-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Allroad (5-Türer) Kombi | 2012-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Multiwagon (5-Türer) Kombi | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Terracan (5-Türer) SUV | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (5-Türer) Schrägheck | 2003-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GL (X166) (5-Türer) SUV | 2013-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LANCIA",
    "Mo": "Musa (5-Türer) MPV | 2004-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan Allspace (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLK (5-Türer) SUV | 2008-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2013-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Terios (5-Türer) SUV | 2006-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Satellite (5-Türer) Bus | 1998-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQB (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Stilo Uproad (5-Türer) SUV | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (S212) (5-Türer) Kombi | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Panda (3-Türer) Schrägheck | 1983-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1990-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T32) (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 2004-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Rasheen (5-Türer) SUV | 1999-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Rasheen (5-Türer) SUV | 1999-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo Tour (5-Türer) MPV | 2012-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer Tahoe (4-Türer) SUV | 1983-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Ipanema (5-Türer) Kombi | 1988-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (I 1T) (5-Türer) MPV | 2003-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X166) (5-Türer) SUV | 2016-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Air (5-Türer) MPV | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Esteem (5-Türer) Kombi | 1998-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (5-Türer) Kombi | 2000-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kangoo (5-Türer) Van | 1997-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Kombi | 2015-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1999-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (5-Türer) Schrägheck | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 Sportback e-tron (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul EV (5-Türer) Schrägheck | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2010-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Evoque (5-Türer) SUV | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E170) (4-Türer) Stufenheck | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Punto Evo (5-Türer) Schrägheck | 2009-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2015-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (E210) (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (4-Türer) Stufenheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan (5-Türer) SUV | 2014-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tacoma (4-Türer) Doppelkabine | 2015-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Schrägheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (T6) (4-Türer) Doppelkabine | 2011-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Sealion 7 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Stelvio (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DFSK",
    "Mo": "Seres 5 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Grand C4 SpaceTourer (5-Türer) MPV | 2014-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 Cross Country (4-Türer) Stufenheck | 2015-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne Coupé (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Soul (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Espace (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A7 (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 3500 (4-Türer) Doppelkabine | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 3500 HD (4-Türer) Pickup | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Viva (5-Türer) Schrägheck | 2015-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Picanto (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Sport (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mustang Mach-E (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2006-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Rumion (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 2500 HD (4-Türer) Pickup | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-60 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal (4-Türer) Stufenheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. III) (5-Türer) Schrägheck | 2014-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP130) (5-Türer) Schrägheck | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (4-Türer) Standard Cab | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Twingo (5-Türer) Schrägheck | 2014-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (XP150) (XP150) (4-Türer) Stufenheck | 2017-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 (5-Türer) Kombi | 2010-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX1L (U12) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (Mk. III) (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Freelander 2 (Mk. II) (5-Türer) SUV | 2007-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "ES-Series (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Schrägheck | 2012-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Doppelkabine | 2005-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2016-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 SpaceTourer (MK II) (5-Türer) MPV | 2014-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAC",
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAC",
    "Mo": "JS4 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Extra Cab | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S90 (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 1500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera Sport Turismo (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vigo (4-Türer) Doppelkabine | 2004-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DODGE",
    "Mo": "Ram 2500 (4-Türer) Doppelkabine | 2009-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Crew Cab | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. X) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Grand Scénic (Mk. IV) (5-Türer) MPV | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux (4-Türer) Doppelkabine | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Inster (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Inster (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ZEEKR",
    "Mo": "7X (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Tank 300 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "Yaoguang (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "RX (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "RX (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "RX (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "EXEED",
    "Mo": "RX (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "9 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "9 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "9 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "9 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Velar (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L494) (5-Türer) SUV | 2014-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic ((Mk. X)) (5-Türer) Schrägheck | 2017-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LEXUS",
    "Mo": "TX (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "TX (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "T90 (4-Türer) Pickup | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) Crew Cab | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "ZR-V (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "4 (5-Türer) Schrägheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "X-Trail (T33) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "3 (5-Türer) Schrägheck | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Puma (K2) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Capri EV (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "600 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "600 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (BR2) (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAIHATSU",
    "Mo": "Sirion (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (L) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VI) (3-Türer) Schrägheck | 2008-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Note (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 X (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Corsa (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "March (K13) (5-Türer) Schrägheck | 2010-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (U11) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Giulia (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Micra (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. IV) (5-Türer) Schrägheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Auris (5-Türer) Schrägheck | 2006-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. II) (5-Türer) Schrägheck | 2008-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka-e ((B)) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Canyon (4-Türer) Crew Cab | 2015-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. IV) (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Sportsvan (5-Türer) MPV | 2014-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Crossland X (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Fabia (Mk III) (5-Türer) Schrägheck | 2015-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (4-Türer) Stufenheck | 2016-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Citigo (3-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (KB4T) (4-Türer) Pickup | 2005-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "408 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "408 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "408 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Tonale (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Forte (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Spaceback (5-Türer) Schrägheck | 2014-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (VII) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Equinox (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2005-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Arkana (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Fit (5-Türer) Schrägheck | 2008-2014",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q2 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "208 (5-Türer) Schrägheck | 2012-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grandeur (4-Türer) Stufenheck | 2018-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Vezel (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (XW50) (5-Türer) Schrägheck | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLA (C117) (4-Türer) Coupe | 2013-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (III) (5-Türer) Schrägheck | 2005-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W246) (5-Türer) Schrägheck | 2011-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (WL) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed Sportswagon (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee L (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W205) (4-Türer) Stufenheck | 2015-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC90 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "Q30 (5-Türer) Schrägheck | 2016-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Ampera (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Rafale (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2016-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2016,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2017,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2018,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2019,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2020,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2021,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2022,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "E-Class (W213) (4-Türer) Stufenheck | 2016-2023",
    "Y": 2023,
    "c": "f",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JEEP",
    "Mo": "Compass (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2016-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (5-Türer) Schrägheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius Prime (XW60) (5-Türer) Schrägheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ALFA ROMEO",
    "Mo": "Junior (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-9 (Mk. II) (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AIWAYS",
    "Mo": "U5 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (B10) (5-Türer) Schrägheck | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Taycan Sport Turismo (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Sealion 6 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ES5 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "S5 EV (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "08 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "08 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LYNK & CO",
    "Mo": "08 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q6 Sportback e-tron (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 Aircross (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (5-Türer) Schrägheck | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius + (5-Türer) Kombi | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (4-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2008-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1992-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Libero (5-Türer) Kombi | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris (5-Türer) Schrägheck | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1983-1990",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Favorit (5-Türer) Kombi | 1990-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Baleno (5-Türer) Kombi | 1996-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAHINDRA",
    "Mo": "Goa (5-Türer) SUV | 2002-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (III) (5-Türer) Kombi | 1994-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "X-Type (5-Türer) Kombi | 2003-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2007-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Fox (5-Türer) Schrägheck | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W12) (5-Türer) Kombi | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Captiva (5-Türer) SUV | 2006-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "740 (5-Türer) Kombi | 1984-1992",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (XA40) (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (3-Türer) SUV | 2003-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Haval H2 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2012-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2000-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC70 (5-Türer) Kombi | 2003-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (5-Türer) Kombi | 2012-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2009-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Sport (5-Türer) SUV | 1998-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCURY",
    "Mo": "Mountaineer (5-Türer) SUV | 2005-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2004-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (3-Türer) SUV | 2004-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i20 Active (5-Türer) Schrägheck | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1982,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SJ 410 (3-Türer) SUV | 1982-1992",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. I) (5-Türer) SUV | 2007-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Space Wagon (5-Türer) MPV | 1991-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2004-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2004-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Tiguan (Mk. II) (5-Türer) SUV | 2016-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2000-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (Mk. I) (5-Türer) Kombi | 2002-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Grand Livina (5-Türer) MPV | 2009-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (3-Türer) SUV | 1996-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (5-Türer) MPV | 2001-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Kombi | 1996-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL7 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Atlas Cross Sport (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SERES",
    "Mo": "M7 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SERES",
    "Mo": "M7 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "HS (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F55) (5-Türer) Schrägheck | 2014-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Yaris Cross (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Grandland X (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2007-2013",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC40 (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL8 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Grand Vitara (5-Türer) SUV | 2005-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZS (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "S-Cross (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV3 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES6 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLC (X253) (5-Türer) SUV | 2015-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Aviator (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ES8 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit (4-Türer) Van | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class Marco Polo (4-Türer) Bus | 2014-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2012-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal U (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Seal U (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Transit Custom (4-Türer) Van | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (F10) (4-Türer) Stufenheck | 2010-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2003-2013",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Lafesta (5-Türer) MPV | 2011-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "WRX (4-Türer) Stufenheck | 2018-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Ceed (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Premacy (5-Türer) MPV | 2004-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "4-Series Gran Coupé (G22) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2010-2022",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Crafter (SY/SZ) (4-Türer) Van | 2017-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "California (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2003-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Master (4-Türer) Van | 2010-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (5-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (4-Türer) Van | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2004-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Expert (4-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i5 (G60) (4-Türer) Stufenheck | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i5 (G60) (4-Türer) Stufenheck | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 90 (3-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Biante (5-Türer) MPV | 2008-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (3-Türer) Schrägheck | 2005-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (4-Türer) Van | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (4-Türer) Van | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (4-Türer) Van | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (4-Türer) Van | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Express (4-Türer) Van | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (5-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (4-Türer) MPV | 2008-2017",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "i4 (G26) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "3 (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (5-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (5-Türer) Schrägheck | 2012-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "SCUDO Van (4-Türer) Van | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Kluger (5-Türer) SUV | 2014-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2011-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Aircross (5-Türer) SUV | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Dokker (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (4-Türer) Doppelkabine | 2010-2022",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "S-Class (W222) (4-Türer) Stufenheck | 2014-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Proceed (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Solterra (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (3-Türer) Schrägheck | 2004-2009",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) Van | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W906) (4-Türer) Van | 2006-2018",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 1996,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 1997,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 1998,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 1999,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2000,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2001,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2002,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 1996-2006",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (2-Türer) Einzelkabine | 2010-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2003,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T5) (T5) (4-Türer) Van | 2003-2015",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (GT) (5-Türer) Schrägheck | 2017-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Double Cab (4-Türer) Pickup | 2015-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Proace City Verso (5-Türer) MPV | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2005-2010",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2008-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2014-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "1-Series (3-Türer) Schrägheck | 2007-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "R-Class (W251) (5-Türer) Kombi | 2006-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RIVIAN",
    "Mo": "R1S (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Levorg (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV200 (5-Türer) MPV | 2009-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 110 (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2016,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. IV) (5-Türer) SUV | 2009-2017",
    "Y": 2017,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Yuan Plus (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Swace (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOYAH",
    "Mo": "Free (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOYAH",
    "Mo": "Free (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOYAH",
    "Mo": "Free (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOYAH",
    "Mo": "Free (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Cooper (F56) (3-Türer) Schrägheck | 2014-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "ET5 Touring (5-Türer) Kombi | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "EV9 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.Buzz People (Long Wheel Base) (Long Wheel Base) (5-Türer) MPV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "NV400 (4-Türer) Van | 2010-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Courier (5-Türer) MPV | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "e-NV200 (5-Türer) Van | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series (E90) (4-Türer) Stufenheck | 2005-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Triton (4-Türer) Pickup | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touareg (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Defender 130 7-seater (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira Life (5-Türer) Bus | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W245) (5-Türer) Schrägheck | 2005-2011",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (IV) (5-Türer) Kombi | 2009-2014",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 Cross Country (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus Active (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KGM",
    "Mo": "Actyon (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (F31) (5-Türer) Kombi | 2012-2019",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Trax (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ZEEKR",
    "Mo": "007GT (5-Türer) Kombi | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "E-5008 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "E-5008 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Astra (5-Türer) Kombi | 2007-2010",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Mokka (5-Türer) SUV | 2013-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Formentor (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q8 Sportback e-tron (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-50 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scenic E-Tech (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Suburban (5-Türer) SUV | 2015-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Elroq (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carnival (5-Türer) MPV | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (DG; GM_W) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2015-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. III) (5-Türer) MPV | 2013-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (AL20) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Rondo (5-Türer) MPV | 2013-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "3-Series Touring (G21) (5-Türer) Kombi | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Nautilus (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LINCOLN",
    "Mo": "Nautilus (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan Electric (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Macan Electric (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BYD",
    "Mo": "Tang (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2005,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2006,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Zafira (5-Türer) MPV | 2005-2011",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "SX4 S-Cross (5-Türer) SUV | 2014-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX3 (5-Türer) SUV | 2021-2025",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q5 (8R) (5-Türer) SUV | 2008-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "S-Max (5-Türer) MPV | 2015-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Altea Freetrack (5-Türer) MPV | 2007-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. IV) (5-Türer) Kombi | 2007-2014",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-90 (KK) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-90 (KK) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Tourneo Connect (5-Türer) MPV | 2014-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V60 Cross Country (5-Türer) Kombi | 2015-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (NQ5) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "DS",
    "Mo": "DS7 Crossback (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2018-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "XC60 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Cee'd (SW) (5-Türer) Kombi | 2012-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (TL) (5-Türer) SUV | 2015-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "Escalade ESV (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Outback (V) (5-Türer) Kombi | 2014-2020",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (Sport tourer) (5-Türer) Kombi | 2008-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Insignia (5-Türer) Kombi | 2008-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLA (H247) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "L200 Club Cab (2-Türer) Pickup | 2016-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2004,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2005,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Dispatch (4-Türer) Van | 2007-2016",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T6/T6.1) (T6/T6.1) (4-Türer) Bus | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PROACE Van (4-Türer) Van | 2016-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Movano (Mk. III) (4-Türer) Van | 2010-2021",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Shuttle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T7) (4-Türer) Bus | 2025-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2011,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2012,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2013,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2014,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caravelle (T5) (T5) (4-Türer) Bus | 2010-2015",
    "Y": 2015,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2018,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2019,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2020,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2021,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2022,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2023,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2024,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Sprinter (W907) (4-Türer) Van | 2018-",
    "Y": 2025,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "HiAce (XH10) (4-Türer) Van | 2007-2012",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Transporter (T6/T6.1) (T6/T6.1) (4-Türer) Van | 2015-2024",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Commodore (5-Türer) Kombi | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8Y) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "ASX (5-Türer) SUV | 2010-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Grand Santa Fe (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "4008 (5-Türer) SUV | 2012-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Terramar (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 SW (5-Türer) Kombi | 2014-2021",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SERES",
    "Mo": "7 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SERES",
    "Mo": "7 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Berlingo Multispace (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X1 (E84) (5-Türer) SUV | 2009-2015",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Vitara (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2007,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2008,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2007-2011",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Discovery (Mk. V) (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "XPENG",
    "Mo": "G9 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (OS) (OS) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sante Fe Sport (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Zafira (5-Türer) MPV | 2012-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "e-Niro (DE) (5-Türer) SUV | 2018-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q4 e-tron (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NIO",
    "Mo": "EL6 (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Space Cab | 2020-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LOTUS",
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LOTUS",
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "LOTUS",
    "Mo": "Eletre (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Ioniq 9 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Niro/Niro EV (SG2) (SG2) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Navara (D23) (4-Türer) Doppelkabine | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (HM) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "I-Pace (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "Q3 Sportback (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Venga (5-Türer) Schrägheck | 2010-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger Raptor (4-Türer) Doppelkabine | 2020-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Roc (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "CC (4-Türer) Coupe | 2012-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-5 (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. IV) (5-Türer) MPV | 2017-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Sandero Stepway (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (MK. V) (MK.V) (5-Türer) SUV | 2019-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat (B8) (4-Türer) Stufenheck | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2016-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Jazz (Mk. IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JEEP",
    "Mo": "Grand Cherokee (5-Türer) SUV | 2011-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat CC (4-Türer) Coupe | 2008-2011",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "bZ4X (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MG",
    "Mo": "5 (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CADILLAC",
    "Mo": "LYRIQ (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 Sedan (CN7) (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CUPRA",
    "Mo": "Tavascan (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (4-Türer) Stufenheck | 2005-2011",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "S60 (4-Türer) Stufenheck | 2010-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-30 (DM) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "León (IV) (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Crew Max | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Santa Fe (5-Türer) SUV | 2013-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FISKER",
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FISKER",
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FISKER",
    "Mo": "Ocean (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Vellfire (AH40) (5-Türer) MPV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado (4-Türer) Doppelkabine | 2014-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Arteon Shooting Brake (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Etios (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Venue (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 Picasso (MK II) (5-Türer) MPV | 2013-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2013-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Crew Cab | 2015-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8P) (5-Türer) Schrägheck | 2004-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Stargazer (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) Schrägheck | 2010-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Mokka X ((B)) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (U06) (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "Grande Punto (5-Türer) Schrägheck | 2005-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Juke (Mk. II) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "6 (4-Türer) Stufenheck | 2013-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "GMC",
    "Mo": "Sierra 1500 (4-Türer) Pickup | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Tundra (4-Türer) Doppelkabine | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Cayenne (9YA) (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K5 (4-Türer) Stufenheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "LAND ROVER",
    "Mo": "Range Rover Sport (L461) (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DENZA",
    "Mo": "D9 (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Silverado 1500 (4-Türer) Pickup | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ertiga (5-Türer) MPV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ë-C4 (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Electric (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Electric (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "2-Series Active Tourer (F45) (5-Türer) MPV | 2014-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "ix35 FCEV (5-Türer) SUV | 2013-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "T-Cross (5-Türer) SUV | 2019-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PORSCHE",
    "Mo": "Panamera (5-Türer) Sportback | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia Grand Sport (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2009-2023",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (5-Türer) Schrägheck | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. V) (4-Türer) Stufenheck | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.7 (5-Türer) Schrägheck | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.7 (5-Türer) Schrägheck | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Austral (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (5-Türer) Schrägheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BYD",
    "Mo": "Dolphin (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "S10 (4-Türer) Doppelkabine | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (3-Türer) Schrägheck | 2004-2007",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Symbioz (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Rapid Liftback (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "HR-V (5-Türer) SUV | 2015-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Frontier (4-Türer) King Cab | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "108 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Elantra (AD) (4-Türer) Stufenheck | 2016-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Lacetti Premiere (4-Türer) Stufenheck | 2009-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ISUZU",
    "Mo": "D-Max (4-Türer) Crew Cab | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra Sports Tourer (5-Türer) Kombi | 2016-2022",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Kona (SX2) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Amarok (Mk. II) (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Aqua (XP210) (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "CX-3 (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Grandland (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (B9) (5-Türer) Schrägheck | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (B9) (5-Türer) Schrägheck | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Colorado (4-Türer) Pickup | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "eT90 (4-Türer) Pickup | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Legacy (VI) (4-Türer) Stufenheck | 2014-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (2-Türer) Einzelkabine | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk II) (4-Türer) Doppelkabine | 2012-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A5 Sportback (F5) (5-Türer) Schrägheck | 2017-2025",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Harrier (XU80) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk IV, QL) (5-Türer) SUV | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (F54) (5-Türer) Kombi | 2016-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (Mk. V) (4-Türer) Stufenheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "HB20 (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (Mk. VI) (MK. VI) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Doppelkabine | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "MAZDA",
    "Mo": "BT-50 (Mk. III) (4-Türer) Pickup | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "BMW",
    "Mo": "iX2 (U10) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "E-Pace (5-Türer) SUV | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Highlander (XU70) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "2008 (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OMODA",
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "OMODA",
    "Mo": "C9 (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SMART",
    "Mo": "#5 (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAXUS",
    "Mo": "G70 (5-Türer) MPV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAXUS",
    "Mo": "G70 (5-Türer) MPV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "Y": 2002,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "Y": 2003,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "Y": 2004,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "Y": 2005,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2002-2006",
    "Y": 2006,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "JAGUAR",
    "Mo": "XF Sportbrake (5-Türer) Kombi | 2018-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Grand Highlander (AS10) (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Grand Highlander (AS10) (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TESLA",
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "Y": 2015,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "TESLA",
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "Y": 2016,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "TESLA",
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "Y": 2017,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "TESLA",
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "Y": 2018,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "TESLA",
    "Mo": "Model S (5-Türer) Schrägheck | 2015-2019",
    "Y": 2019,
    "c": "f",
    "T": "No"
  },
  {
    "Ma": "MAXUS",
    "Mo": "MIFA 7 (5-Türer) MPV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAXUS",
    "Mo": "MIFA 7 (5-Türer) MPV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "Maxus 7 (5-Türer) MPV | 2025-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Fielder (E160) (5-Türer) Kombi | 2012-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Touran (II 5T) (5-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Crosstrek (GU) (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Casper Electric (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Casper Electric (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Multivan (T7) (T7) (5-Türer) MPV | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "GMC",
    "Mo": "HUMMER EV Pickup (4-Türer) Pickup | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2009,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2010,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2011,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "5008 (5-Türer) MPV | 2009-2017",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "Nemo (4-Türer) Van | 2008-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "Y": 2006,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "Y": 2007,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "Y": 2008,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "Y": 2009,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Galaxy (5-Türer) MPV | 2006-2010",
    "Y": 2010,
    "c": "e",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLE Coupé (C292) (5-Türer) SUV | 2015-2019",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE SUV (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Combo (4-Türer) Van | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQE (4-Türer) Stufenheck | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "CLS (C257) (4-Türer) Coupe | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2002,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2003,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Probox (XP50) (5-Türer) Van | 2002-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2014-2021",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "3008 (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (4-Türer) Stufenheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "ORA",
    "Mo": "Good Cat (5-Türer) Schrägheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "308 (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (4-Türer) Stufenheck | 2018-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (4-Türer) Stufenheck | 2012-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Optima (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Rio (Mk. III) (5-Türer) Schrägheck | 2012-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Megane E-Tech (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "DACIA",
    "Mo": "Logan (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (4-Türer) Stufenheck | 2009-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Captur (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Clio (IV) (5-Türer) Schrägheck | 2013-2019",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf (V) (5-Türer) Schrägheck | 2004-2007",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FORD",
    "Mo": "Fiesta (5-Türer) Schrägheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500L (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C1 (5-Türer) Schrägheck | 2014-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C3 (SX/SY) (5-Türer) Schrägheck | 2017-2024",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 (4-Türer) Stufenheck | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Mii (3-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (Mk. XI) (5-Türer) Schrägheck | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V40 (5-Türer) Schrägheck | 2012-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 Sportback (8V) (5-Türer) Schrägheck | 2013-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Schrägheck | 2010-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia (Mk. III) (4-Türer) Stufenheck | 2013-2020",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "Cerato (4-Türer) Stufenheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Corsa F (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Schrägheck | 2016-2022",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Prius (5-Türer) Schrägheck | 2009-2015",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra Sports Tourer (L) (5-Türer) Kombi | 2022-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2003,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2004,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2005,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2006,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2007,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A3 (8P) (3-Türer) Schrägheck | 2003-2012",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo (Mk V) (5-Türer) Schrägheck | 2009-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Camry (XV80) (4-Türer) Stufenheck | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "New Onix (5-Türer) Schrägheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 (4-Türer) Stufenheck | 2011-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "KIA",
    "Mo": "K3 (4-Türer) Stufenheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SKODA",
    "Mo": "Scala (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "AUDI",
    "Mo": "A1 (5-Türer) Schrägheck | 2012-2018",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ibiza (Mk. V) (5-Türer) Schrägheck | 2017-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Sonata (DN8) (4-Türer) Stufenheck | 2020-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "FIAT",
    "Mo": "500X (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Accent (4-Türer) Stufenheck | 2018-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C4 X (4-Türer) Stufenheck | 2023-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Golf Variant/Sportcombi/SportWagen (A8) (5-Türer) Kombi | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (Mk. III) (5-Türer) Kombi | 2001-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Previa (5-Türer) MPV | 2006-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Uno (5-Türer) Kombi | 1984-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Octavia Scout (Mk III) (5-Türer) Kombi | 2014-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubvan (4-Türer) Van | 2013-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHRYSLER",
    "Mo": "Town & Country (5-Türer) MPV | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "XL-7 (5-Türer) SUV | 1998-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Maverick (3-Türer) SUV | 1993-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Trajet (5-Türer) MPV | 2000-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner Tepee (5-Türer) MPV | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "200-500 (W124) (5-Türer) Kombi | 1985-1989",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1982,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1983,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1984,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1985,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "760 (5-Türer) Kombi | 1982-1990",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "V50 (5-Türer) Kombi | 2004-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sportage (Mk II) (5-Türer) SUV | 2004-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser 120 (5-Türer) SUV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1994-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Cruze (5-Türer) Schrägheck | 2001-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B5/B5.5) (5-Türer) Kombi | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Bipper (3-Türer) Van | 2008-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser (5-Türer) SUV | 2003-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 2005-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Antara (5-Türer) SUV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic Shuttle (5-Türer) MPV | 1988-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord (5-Türer) Kombi | 2003-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2000-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Scorpio (5-Türer) Kombi | 1994-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JMC",
    "Mo": "Landwind (5-Türer) SUV | 2005-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "4 Runner (5-Türer) SUV | 1990-1995",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Praktik (5-Türer) Kombi | 2007-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Sintra (4-Türer) MPV | 1996-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Primera (W10) (5-Türer) Kombi | 1991-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Wagon R (3-Türer) MPV | 1999-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Sierra (5-Türer) Kombi | 1987-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Focus (5-Türer) Kombi | 2004-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Sigma (5-Türer) Kombi | 1993-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Journey (5-Türer) SUV | 2008-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Kuga (5-Türer) SUV | 2012-2020",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic (Mk. III) (5-Türer) MPV | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Outlander (Mk.II) (5-Türer) SUV | 2006-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X3 (5-Türer) SUV | 2003-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Nubira (5-Türer) Kombi | 2004-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Lancer (5-Türer) Kombi | 1993-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "INFINITI",
    "Mo": "QX50 (5-Türer) SUV | 2014-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1986,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1987,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Pathfinder (WD21) (3-Türer) SUV | 1986-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Astra (5-Türer) Kombi | 1992-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Matiz (Mk I) (5-Türer) Schrägheck | 1998-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Accord Tourer (5-Türer) Kombi | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Delica Mini (5-Türer) SUV | 2023-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Kodiaq (5-Türer) SUV | 2017-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "PicNic (5-Türer) MPV | 1997-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "100 Avant (5-Türer) Kombi | 1990-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sedona (5-Türer) MPV | 2005-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Frontera Sport (3-Türer) SUV | 1999-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Spacio (5-Türer) MPV | 1997-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DODGE",
    "Mo": "Caravan / Grand Caravan (5-Türer) MPV | 1996-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "JONWAY",
    "Mo": "Ufo (3-Türer) SUV | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-7X (5-Türer) SUV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Space Fox (5-Türer) Kombi | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W203) (5-Türer) Kombi | 2004-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Z (3-Türer) Schrägheck | 1999-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DAEWOO",
    "Mo": "Nubira (5-Türer) Kombi | 1997-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Rezzo (5-Türer) Kombi | 2005-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Fiorino (4-Türer) Van | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Doblo (5-Türer) Van | 2010-2022",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Bronco Sport (CX430) (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Alhambra (Mk II) (5-Türer) MPV | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "GREAT WALL",
    "Mo": "Steed (4-Türer) Doppelkabine | 2016-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Avante (5-Türer) Kombi | 1996-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Life (5-Türer) MPV | 2004-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Avensis Verso (5-Türer) MPV | 2001-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (5-Türer) SUV | 1995-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "iMax (5-Türer) Bus | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "X5 (5-Türer) SUV | 2000-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (5-Türer) SUV | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Starex (5-Türer) MPV | 2008-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "PEUGEOT",
    "Mo": "Partner (4-Türer) Van | 2008-2018",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Ranger (4-Türer) Super Cab | 2011-2022",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 1998-2002",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 1991-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Tahoe (5-Türer) SUV | 2000-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy California (5-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Life (5-Türer) Kombi | 2001-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Korando (C200) (5-Türer) SUV | 2011-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Ipsum (5-Türer) MPV | 2001-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLVO",
    "Mo": "850 (5-Türer) Kombi | 1993-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Forman (5-Türer) Kombi | 1990-1994",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-4X (5-Türer) SUV | 2011-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-4X (5-Türer) SUV | 2011-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Polo Variant (Mk III) (5-Türer) Kombi | 1996-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Mondeo (MK I/MK II) (5-Türer) Kombi | 1993-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Frontera (5-Türer) SUV | 1999-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Terrano (R20) (5-Türer) SUV | 2003-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Kei (5-Türer) MPV | 1998-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MINI",
    "Mo": "Clubman (4-Türer) Kombi | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Carens (Mk. I) (5-Türer) MPV | 2002-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Odyssey (5-Türer) MPV | 2003-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2017-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Qashqai (5-Türer) SUV | 2007-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Avant (5-Türer) Kombi | 1998-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Land Cruiser Prado (5-Türer) SUV | 2002-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Edge (5-Türer) SUV | 2007-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Bora Variant (5-Türer) Kombi | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C5 (5-Türer) Kombi | 2004-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Dingo (5-Türer) MPV | 1999-2001",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Zafira (5-Türer) MPV | 2001-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LEXUS",
    "Mo": "RX (5-Türer) SUV | 2004-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero (5-Türer) SUV | 2007-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. III) (5-Türer) Kombi | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "DACIA",
    "Mo": "Bigster (5-Türer) SUV | 2025-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SAAB",
    "Mo": "9-3 SportCombi (5-Türer) Kombi | 2005-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo Maxi (4-Türer) Van | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taos (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Stonic (5-Türer) SUV | 2017-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Taigo (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "ZT-T (5-Türer) Kombi | 2002-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "JM (5-Türer) SUV | 2004-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "MPV (5-Türer) MPV | 1997-1999",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Passat Variant (B7) (5-Türer) Kombi | 2010-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Ignis (5-Türer) Schrägheck | 2000-2009",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "Sorento (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Telstar (5-Türer) Kombi | 1992-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "5 (5-Türer) MPV | 2004-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Roomster Scout (5-Türer) MPV | 2007-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Pajero Pinin (5-Türer) SUV | 1998-2007",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "ZX (5-Türer) Kombi | 1992-1998",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "Musso (5-Türer) SUV | 1996-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "75 (5-Türer) Kombi | 1999-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Spark (5-Türer) Schrägheck | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Mégane (Mk. II) (5-Türer) Kombi | 2003-2008",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Jetta Variant (5-Türer) Kombi | 2008-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "Tucson (5-Türer) SUV | 2010-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MG",
    "Mo": "GS (5-Türer) SUV | 2015-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross UP (5-Türer) Schrägheck | 2013-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SK) (5-Türer) SUV | 2019-2024",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Exeo (5-Türer) Kombi | 2009-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Scénic X Mod (5-Türer) MPV | 2012-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HOLDEN",
    "Mo": "Captiva (5-Türer) SUV | 2006-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Legnum (5-Türer) Kombi | 1997-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "ROVER",
    "Mo": "Streetwise (5-Türer) Schrägheck | 2004-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Strada (2-Türer) Große Fahrerkabine | 2004-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Challenger (5-Türer) SUV | 2009-2016",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "Civic (5-Türer) Kombi | 1997-2000",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Escape (5-Türer) SUV | 2008-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Sharan (5-Türer) MPV | 2016-2022",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "GLS (X167) (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Impreza (5-Türer) Kombi | 1993-2004",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Patrol GR (Y61) (5-Türer) SUV | 2005-2013",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Lacetti (5-Türer) Kombi | 2004-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer Sport (3-Türer) SUV | 2001-2010",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Sunny (Y10) (5-Türer) Kombi | 1991-1996",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Cargo (4-Türer) Van | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (4-Türer) MPV | 2015-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (4-Türer) MPV | 2021-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Tribeca (5-Türer) SUV | 2008-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "Vito (5-Türer) Bus | 1997-2003",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "V-Class (5-Türer) Van | 1997-2014",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1988,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1989,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1990,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1991,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1992,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1993,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1994,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "626 (5-Türer) Kombi | 1988-1997",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Hilux SW4 (5-Türer) SUV | 2006-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "HYUNDAI",
    "Mo": "i30 SW (5-Türer) Kombi | 2007-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A4 Allroad (5-Türer) Kombi | 2008-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MAZDA",
    "Mo": "Flair Crossover (5-Türer) MPV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 1995,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 1996,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 1997,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "BLAZER (3-Türer) SUV | 1995-2005",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MITSUBISHI",
    "Mo": "Montero (3-Türer) SUV | 1999-2006",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Cross Touran (5-Türer) MPV | 2006-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "XV (GT) (5-Türer) SUV | 2017-2023",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SEAT",
    "Mo": "Ateca (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "CITROËN",
    "Mo": "C-crosser (5-Türer) SUV | 2007-2012",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Saveiro (2-Türer) Pickup | 2010-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SKODA",
    "Mo": "Superb (Mk II) (5-Türer) Kombi | 2009-2015",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SSANGYONG",
    "Mo": "XLV (5-Türer) SUV | 2016-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "M-Class (W164) (5-Türer) SUV | 2005-2011",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 1998,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 1999,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2000,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2001,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2002,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2003,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2004,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2005,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2006,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2007,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "LADA",
    "Mo": "111 (5-Türer) Kombi | 1998-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "Y": 2018,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "OPEL",
    "Mo": "Karl rocks (5-Türer) Schrägheck | 2017-2019",
    "Y": 2019,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2008,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2009,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2010,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2011,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2012,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2013,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2014,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2015,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2016,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "FIAT",
    "Mo": "Qubo (5-Türer) MPV | 2008-2017",
    "Y": 2017,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUBARU",
    "Mo": "Forester (SJ) (5-Türer) SUV | 2013-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "FORD",
    "Mo": "Explorer (U502) (5-Türer) SUV | 2016-2019",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "KIA",
    "Mo": "XCeed (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi (5-Türer) Van | 2008-2015",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "RAV 4 (5-Türer) SUV | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQC (5-Türer) SUV | 2020-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX (5-Türer) SUV | 2022-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX (5-Türer) SUV | 2022-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX (5-Türer) SUV | 2022-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "iX (5-Türer) SUV | 2022-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Kicks (P15) (5-Türer) SUV | 2016-2024",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2012,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2013,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2014,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2015,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2016,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "HONDA",
    "Mo": "CR-V (5-Türer) SUV | 2012-2018",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2007,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2008,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2009,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2010,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2011,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "C-Class (W204) (4-Türer) Stufenheck | 2007-2014",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Across (5-Türer) SUV | 2021-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Across (5-Türer) SUV | 2021-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Across (5-Türer) SUV | 2021-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Across (5-Türer) SUV | 2021-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "SUZUKI",
    "Mo": "Across (5-Türer) SUV | 2021-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2008,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2009,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VAUXHALL",
    "Mo": "Insignia (4-Türer) Stufenheck | 2008-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2017,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2018,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Bolt (5-Türer) Schrägheck | 2017-2023",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2012,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2013,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2014,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2015,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "A-Class (W176) (5-Türer) Schrägheck | 2012-2018",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "ACURA",
    "Mo": "ZDX (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer EV (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "CHEVROLET",
    "Mo": "Blazer EV (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "B-Class (W247) (5-Türer) Schrägheck | 2019-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G60) (4-Türer) Stufenheck | 2024-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "BMW",
    "Mo": "5-Series (G60) (4-Türer) Stufenheck | 2024-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy Maxi Life (5-Türer) MPV | 2016-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2016,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "Caddy (4-Türer) Van | 2016-2020",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "e-tron GT (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Kadjar (5-Türer) SUV | 2015-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2010,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2011,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2012,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2013,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2014,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2015,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2016,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2010-2017",
    "Y": 2017,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2018,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2019,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2020,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Leaf (5-Türer) Schrägheck | 2018-2025",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2019,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2020,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2021,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2022,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2023,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "TOYOTA",
    "Mo": "Corolla Touring Sports (5-Türer) Kombi | 2019-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "AUDI",
    "Mo": "A6 Sportback e-tron (5-Türer) Schrägheck | 2025-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.7 Tourer (5-Türer) Kombi | 2024-",
    "Y": 2024,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "VOLKSWAGEN",
    "Mo": "ID.7 Tourer (5-Türer) Kombi | 2024-",
    "Y": 2025,
    "c": "b",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2017,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2018,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2019,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2020,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2021,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2022,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2023,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2024,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "MAN",
    "Mo": "TGE (4-Türer) Van | 2017-",
    "Y": 2025,
    "c": "d",
    "T": "Yes"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "Y": 2021,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "Y": 2022,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "Y": 2023,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "Y": 2024,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "NISSAN",
    "Mo": "Versa (N18) (4-Türer) Stufenheck | 2021-",
    "Y": 2025,
    "c": "c",
    "T": "No"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "RENAULT",
    "Mo": "Duster (5-Türer) SUV | 2024-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2020,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2021,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2022,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2023,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2024,
    "c": "a",
    "T": "Yes"
  },
  {
    "Ma": "MERCEDES-BENZ",
    "Mo": "EQV (5-Türer) MPV | 2020-",
    "Y": 2025,
    "c": "a",
    "T": "Yes"
  }
]